/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Dialect_Label_Generic_CsvInputs */

const cs_import_dialect_label_generic_csv = /** @type {(inputs: Import_Dialect_Label_Generic_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obecné CSV`)
};

const en_import_dialect_label_generic_csv = /** @type {(inputs: Import_Dialect_Label_Generic_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generic CSV`)
};

/**
* | output |
* | --- |
* | "Generic CSV" |
*
* @param {Import_Dialect_Label_Generic_CsvInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_dialect_label_generic_csv = /** @type {((inputs?: Import_Dialect_Label_Generic_CsvInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Dialect_Label_Generic_CsvInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_dialect_label_generic_csv(inputs)
	return cs_import_dialect_label_generic_csv(inputs)
});